module.exports = __webpack_public_path__ + "static/media/MOTIVATION_EXT_POS_EXT_NEG.0dd114c3.md";